/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Address {
  addressId?: number;
  addressType?: Address.AddressTypeEnum;
  city?: string;
  cityCode?: number;
  country?: string;
  countryCode?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  name?: string;
  neighborhood?: string;
  personId?: number;
  phone?: string;
  postOfficeBox?: string;
  postalCode?: string;
  recipientName?: string;
  reference?: string;
  shippingPrice?: number;
  state?: string;
  stateCode?: number;
  street?: string;
  streetExtension?: string;
  streetNumber?: string;
  subscriber?: boolean;
}
export namespace Address {
  export type AddressTypeEnum = 'SHIPPING' | 'BILLING';
  export const AddressTypeEnum = {
    SHIPPING: 'SHIPPING' as AddressTypeEnum,
    BILLING: 'BILLING' as AddressTypeEnum
  };
}
